import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const UserClassificationsReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions("EffectiveDate"),
    ...FormActionReducer.defaultRecordState()
  },
  action) => {

  if (action.scope === ScopeConstants.USER_CLASSIFICATION) {
    return FormActionReducer.reduce(action, state)
  }

  return state
}